import React from 'react';
import { toAbsoluteUrl } from '../../utils';
import clsx from 'clsx';

interface ISearchInputProps {
	placeholder: string;
	searchValue?: string;
	additionalClass?: string;
	setSearchValue?: (value: string) => void;
	isDisabled?: boolean;
}

export const SearchInput = (props: ISearchInputProps): JSX.Element => {
	const { placeholder, additionalClass, searchValue, setSearchValue, isDisabled } = props;

	return (
		<div
			className={clsx('applications-search-container bg-white p-0 p-md-2 ps-5 rounded-2', additionalClass && additionalClass)}>
			<input
				type="text"
				placeholder={placeholder}
				className="form-control form-control-sm form-control-solid input-placeholder bg-transparent border-0 fs-6"
				onChange={(e): void => setSearchValue(e.target.value)}
				disabled={isDisabled}
				value={searchValue}
			/>
			<img
				src={toAbsoluteUrl('/media/icons/search.svg')}
				className="applications-search-search-icon"
				alt="search"
			/>
		</div>
	);
};
